import React, { Component } from "react";

import { connect } from "react-redux";
import { toastr } from "react-redux-toastr";
import { Row } from "reactstrap";
import { bindActionCreators } from "redux";

import { logout } from "../../../../actions/baseActions";
import { setObj } from "../../../../actions/noteActions";
import Loading from "../../../../components/Loading";
import ProtectedRoute from "../../../../components/ProtectedRoute";
import DataTable from "../../../../components/Tables/tables";
import URL from "../../../../config/api";
import axios from "../../../../config/axios";

class QuestionListList extends Component {
  constructor() {
    super();
    this.state = {
      loading: true,
      activities_list: [],
      lists: []
    };

    this.error = this.error.bind(this);
    this.allocateAction = this.allocateAction.bind(this);
  }

  error = response => {
    if (response === "Unauthorized") {
      this.props.logout(this.props.user.token);
    } else {
      toastr.error("Fail", response);
    }
  };

  componentDidMount() {
    this.props.setObj(16, this.props.currentRoute, this.props.currentRoute);

    let objActivity = {
      user_id: this.props.user.user.id,
      evaluation: true
    };

    axios
      .all([
        axios.post(
          `${URL.api}evaluation/question/lists/list`,
          this.props.match.params.id,
          { headers: { authorization: `Bearer ${this.props.user.token}` } }
        ),
        axios.post(`${URL.api}activity/activity/list`, objActivity, {
          headers: { authorization: `Bearer ${this.props.user.token}` }
        })
      ])
      .then(
        axios.spread(
          (respQuestions, respActivities) => {
            if (respQuestions.data.success) {
              this.setState({
                lists: respQuestions.data.data,
                activities_list: respActivities.data.data,
                loading: false
              });
            }
          },
          error => {
            this.error(error.response.statusText);
          }
        )
      );
  }

  createLists = () => {
    this.props.history.push("/question/list/create");
  };

  allocateAction = row => {
    let check = false;
    let activityId = 0;
    for (let i = 0; i < this.state.activities_list.length; i++) {
      if (row.id === this.state.activities_list[i].items[0].obj_id) {
        activityId = this.state.activities_list[i].id;
        check = true;
      }
    }

    if (check === true) {
      this.props.history.push(`/activity/allocate/${activityId}`);
    } else {
      // ajusteMarvin ajustar habilidade e dificultade
      let obj = {
        name: row.name,
        description: "Avaliação",
        user_id: this.props.user.user.id,
        ability_id: 1,
        difficulty_level_id: 1,
        author: this.props.user.user.username,
        year: new Date().getFullYear(),
        private: true,
        items: [
          {
            type: 12,
            list: {
              id: row.id,
              name: row.name
            }
          }
        ],
        evaluation: true,
        live: false,
        type_id: 4
      };

      axios
        .post(`${URL.api}activity/activity/insert`, obj, {
          headers: { authorization: `Bearer ${this.props.user.token}` }
        })
        .then(resp => {
          if (resp.data.success) {
            this.props.history.push(`/activity/allocate/${resp.data.data}`);
          }
        });
    }
  };

  render() {
    return (
      <div id="list" className="animated fadeIn">
        {this.state.loading ? (
          <Loading top="45" left="50" />
        ) : (
          <Row>
            {this.state.lists ? (
              <DataTable
                list={this.state.lists}
                path="/question/list/create/"
                title="Tabela de lista de questões"
                header={[
                  { name: "id", denomination: "ID" },
                  { name: "name", denomination: "Nome" }
                ]}
                csv
                btnEdit
                insert
                delete
                action
                btnAllocate
                btnPrint={false}
                insertAction={this.createLists}
                allocateAction={this.allocateAction}
              />
            ) : (
              "Carregando..."
            )}
          </Row>
        )}
        <ProtectedRoute routeId={this.props.currentRoute} />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      logout,
      setObj
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(QuestionListList);
